import { createFileRoute } from '@tanstack/react-router'
import { AdminGuard } from '@/components/admin-guard'
import { ClientDashboardLayout } from '@/features/clients/ClientDashboardLayout'

function ClientDashboardRoute() {
  const { companyId } = Route.useParams()
  return (
    <AdminGuard>
      <ClientDashboardLayout companyId={companyId} />
    </AdminGuard>
  )
}

type DashboardSearch = { prep?: true }

// The prep modal opens over any tab from ?prep, which the #cs post links to as ?prep=1.
const PREP_VALUES: unknown[] = [true, 1, '1', 'true']

export const Route = createFileRoute('/clients/$companyId')({
  validateSearch: (search: Record<string, unknown>): DashboardSearch => (PREP_VALUES.includes(search.prep) ? { prep: true } : {}),
  component: ClientDashboardRoute,
})
